import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import AboutSummary from './components/AboutSummary';
import PartnersWall from './components/PartnersWall';
import EventsPreview from './components/EventsPreview';
import EventsGallery from './components/EventsGallery';
import GuestsCarousel from './components/GuestsCarousel';
import MediaCoverage from './components/MediaCoverage';
import DonorsBanner from './components/DonorsBanner';
import Disclaimer from './components/Disclaimer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <AboutSummary />
        <PartnersWall />
        <EventsPreview />
        <EventsGallery />
        <GuestsCarousel />
        <MediaCoverage />
        <DonorsBanner />
        <Disclaimer />
      </main>
      <Footer />
    </div>
  );
}
